<template>
  <div class="wallet-page" :class="{ 'loading': isProcessing }">
    <div :class="{ 'loading': isLoadingChart }">
      <binary-tree-expandable/>
    </div>
  </div>
</template>
<script>

import BinaryTreeExpandable from '@/views/dashboard/components/BinaryTreeExpandable'
import CONSTANT from '@/configs/constant'
export default {
  components: {
    BinaryTreeExpandable
  },
  data () {
    return {
      isLoadingData: false,
      isProcessing: false,
      colors: CONSTANT.COLORS_LEVEL
    }
  },
  computed: {
    isValidatedSearchForm () {
      return this.statForm.affCode && this.statForm.fromTime && this.statForm.toTime
    },
    isLoadingChart () {
      return this.$store.getters.isLoadingChart
    },
    isValidatedForm () {
      return this.currentUser.code && this.form.userCode && this.form.parentCode
    },
    isValidated () {
      return this.form.parentCode && this.form.userCode
    },
    levelColors () {
      return Object.keys(this.colors)
    },
    binaryData () {
      return this.$store.getters.binaryData
    },
    simpleChart () {
      return this.$store.getters.simpleChart
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    const code = this.$route.query.code
    this.$store.dispatch('getBinaryData', code)
  },
  methods: {
  }
}
</script>
